/**
 * Where a captured payment stands in QuickBooks Online (API: QuickbooksOnlineService.getPaymentSyncStatus).
 * Payments QBO sync doesn't apply to (no QBO, sync off, uncaptured / reversed) have no status.
 *
 * - SYNCED: a QBO Payment applied to the order's invoice.
 * - DEPOSIT: sent as the `Deposit` on the order's invoice.
 * - UNAPPLIED: a QBO Payment exists as a customer credit; it is applied once the invoice exists.
 * - WAITING_FOR_INVOICE: sent when the order's invoice is created.
 * - SENDING: being sent right now.
 * - NOT_SENT: should be in QuickBooks and isn't (failed, or never sent) — can be resent.
 * - BLOCKED: larger than the order total, so it is held back.
 */
enum QBOPaymentSyncStatusEnum {
    SYNCED = "synced",
    DEPOSIT = "deposit",
    UNAPPLIED = "unapplied",
    WAITING_FOR_INVOICE = "waiting_for_invoice",
    SENDING = "sending",
    NOT_SENT = "not_sent",
    BLOCKED = "blocked",
}

export default QBOPaymentSyncStatusEnum;
